export function windowLocationReplace(redirectUrl = '', timeout = 0) {
  if (window !== undefined) {
    window.setTimeout(() => {
      window.location.href = redirectUrl;
      return null;
    }, timeout);
  }
}
